import React, { Component } from 'react';
import { connect } from 'react-redux';

import { createStockAccount } from '../actions/StockAccountActions';

import { Pane, Heading, Button } from 'evergreen-ui';
import InfoBlock from '../../common/InfoBlock/InfoBlock';

import { Link } from 'react-router-dom';
import StockAccountForm from '../components/StockAccountForm';

import Configuration from '../Config';

const validation = Configuration.Validations.stockAccount;
const defaultValues = Configuration.Defaults.stockAccount;
const mapValidationErrors = Configuration.ErrorHandler.mapValidationErrors;

class CreateStockAccount extends Component {
    componentDidMount() {
       
    }

    handleSave = (values) => {
        this.props.dispatch(createStockAccount(values));
    }

    render() {
        return (
            <Pane padding={16} paddingTop={0}>
                <Pane display="flex">
                    <Pane>
                        <Link to="/stock-accounts">
                            <Button iconBefore="arrow-left" intent="none">
                                Inapoi la lista conturi
                            </Button>
                        </Link>
                    </Pane>
                </Pane>

                <Pane flex={1} background="tint1" elevation={1} padding={16} marginTop={16}>
                    <Heading size={600}>
                        Cont nou
                    </Heading>
                </Pane>
                
                <Pane display="flex" justifyContent="space-between" flex={1} marginTop={16}>
                    <InfoBlock flex="1">
                        <StockAccountForm 
                            isEdit={false}
                            initialValues={defaultValues}
                            validationSchema={validation}
                            onSave={this.handleSave}
                            errors={this.props.errors}/>
                    </InfoBlock>
                </Pane>

            </Pane>
        )
    }
}

function mapStateToProps(state) {
    return {
        errors: state.stockAccounts.errors.type === 'validation' ? mapValidationErrors(state.stockAccounts.errors.fields): [],
    }
}

export default connect(mapStateToProps)(CreateStockAccount);